type Light = typeof light;
export const light = {
    primary: {
        normal: "#293BDC",
        hover: "#334AF8",
        active: "#2233B1",
        disabled: "#293BDC50",
        subtle: "#A2C2FF",
        strong: "#151C51",
        title:"#5985FF",
        bk00:"#000",
        bk01:"#3F424D",
        bk02:"#2B2F34",
        gr01:"#020202ff",
        gr02:"#D8D8D8",
        // 접근성 gr03:"#000",
       gr03:"#757E9F",
        bl01:"#006AFF",
        bl02:"#5985FF",
        wh01:"#ffffff"
    },
    danger: {
        normal: "#FA3025",
        hover: "#FF726A",
        active: "#E8241A",
        disabled: "#FA302550"
    },
    input: {
        border: " #E4E4E4",
        placeholder: "#818B98",
        text: "#2B2F34",
        // 접근성대비 placeholder: "#000",
        // text: "#000",
        disabled: { border: "#e4e4e4" },
        err: "#FA3025",
        focus: "#006aff",
    },
    button: {
        background: "#006AFF",
        text: "#FFFFFF",
        disabled: {
            background: "#EEF1F4",
            border: "#EEF1F4",
            // 접근성  text: "#000",
            text: "#7E8795",
            text2: "#747483",
        },
    },
};

export const dark = {
    primary: "#2F80ED",
}

declare module '@emotion/react' {
    export interface Theme extends Light {
    }
}